module.exports = __webpack_public_path__ + "img/discover.ef626704.png";